import { tenantManagementActions } from "../../constants/actionTypes";

const tenantCreateUserRequest = (data) => ({
  type: tenantManagementActions.tenantCreateRequest,
  data: data,
});

const tenantCreateUserSuccess = (data) => ({
  type: tenantManagementActions.tenantCreateSuccess,
  data: data,
});

const tenantEditUserRequest = (data) => ({
  type: tenantManagementActions.tenantEditRequest,
  data: data,
});

const tenantEditUserSuccess = (data) => ({
  type: tenantManagementActions.tenantEditSuccess,
  data: data,
});

const getTenantListData = (data) => ({
  type: tenantManagementActions.tenantListGetData,
  payload: data,
});

const setTenantListData = (data) => ({
  type: tenantManagementActions.tenantListSetData,
  payload: data,
});

const getTenantListDataPaginated = (data) => ({
  type: tenantManagementActions.GET_TENANT_LIST_PAGINATED,
  payload: data,
});

const setTenantListDataPaginated = (data) => ({
  type: tenantManagementActions.SET_TENANT_LIST_PAGINATION,
  payload: data,
});
const resetTenantListDataPaginated = (data) => ({
  type: tenantManagementActions.RESET_TENANT_LIST_PAGINATION,
  payload: data,
});

const setTenantListError = (data) => ({
  type: tenantManagementActions.tenantListSetError,
  payload: data,
});

const deleteTenantData = (data) => ({
  type: tenantManagementActions.tenantDeleteData,
  payload: data,
});

const tenantDeleteDataSuccess = (data) => ({
  type: tenantManagementActions.tenantDeleteSuccess,
  payload: data,
});

const tenantActionSuccess = (data) => ({
  type: tenantManagementActions.tenantActionSuccess,
  data: data,
});

const deleteTenantError = (error) => ({
  type: tenantManagementActions.tenantDeleteError,
  payload: error,
});

const playPauseTenantData = (id, data) => ({
  type: tenantManagementActions.tenantPlayPauseData,
  payload: { id, data },
});

const playPauseTenantError = (error) => ({
  type: tenantManagementActions.tenantPlayPauseError,
  payload: error,
});

const viewTenantRequest = (data) => ({
  type: tenantManagementActions.tenantViewRequest,
  data: data,
});

const viewTenantSuccess = (data) => ({
  type: tenantManagementActions.tenantViewSuccess,
  payload: data,
});

const uploadTenantLogo = (data) => ({
  type: tenantManagementActions.UPLOAD_TENANT_LOGO,
  payload: data,
});

const setTenantLogoData = (data) => ({
  type: tenantManagementActions.UPLOAD_TENANT_LOGO_SUCCESS,
  payload: data,
});

const setTenantLogoError = (data) => ({
  type: tenantManagementActions.UPLOAD_TENANT_LOGO_ERROR,
  payload: data,
});

const getAccountManagers = (data) => ({
  type: tenantManagementActions.GET_ACCOUNT_MANAGER_LIST,
  payload: data,
});

const setAccountManagers = (data) => ({
  type: tenantManagementActions.SET_ACCOUNT_MANAGER_LIST,
  payload: data,
});

const setAccountManagersError = (data) => ({
  type: tenantManagementActions.ACCOUNT_MANAGER_LIST_ERROR,
  payload: data,
});

const getCsmAdmins = (data) => ({
  type: tenantManagementActions.GET_CSM_ADMIN_LIST,
  payload: data,
});

const setCsmAdmins = (data) => ({
  type: tenantManagementActions.SET_CSM_ADMIN_LIST,
  payload: data,
});

const setCsmAdminsError = (data) => ({
  type: tenantManagementActions.CSM_ADMIN_LIST_ERROR,
  payload: data,
});

const getMachineCatalogs = () => ({
  type: tenantManagementActions.GET_MACHINE_CATALOG_LIST,
});

const setMachineCatalogs = (data) => ({
  type: tenantManagementActions.SET_MACHINE_CATALOG_LIST,
  payload: data,
});

const setMachineCatalogError = (data) => ({
  type: tenantManagementActions.MACHINE_CATALOG_LIST_ERROR,
  payload: data,
});

const setTenantCreationData = (data) => ({
  type: tenantManagementActions.TENANT_CREATION_SUCCESS,
  payload: data,
});

const getTenantDetailsById = (data) => ({
  type: tenantManagementActions.GET_TENANT_DETAILS_BY_ID,
  payload: data,
});

const setTenantDetailsById = (data) => ({
  type: tenantManagementActions.SET_TENANT_DETAILS_BY_ID,
  payload: data,
});

const setTenantDetailsErrorById = (data) => ({
  type: tenantManagementActions.SET_TENANT_DETAILS_ERROR_BY_ID,
  payload: data,
});

const requestPricingProfile = (data) => ({
  type: tenantManagementActions.REQUEST_PRICING_PROFILE,
  payload: data,
});

const successPricingProfile = (data) => ({
  type: tenantManagementActions.SUCCESS_PRICING_PROFILE,
  payload: data,
});

const errorPricingProfile = (data) => ({
  type: tenantManagementActions.ERROR_PRICING_PROFILE,
  payload: data,
});

const setQuotaFormRequest = (payload) => ({
  type: tenantManagementActions.SET_QUOTA_FORM_REQUEST,
  payload: payload,
});

const setQuotaFormSuccess = (data) => ({
  type: tenantManagementActions.SET_QUOTA_FORM_SUCCESS,
  data: data,
});

const setQuotaFormGetRequest = (id) => ({
  type: tenantManagementActions.SET_QUOTA_FORM_GET_REQUEST,
  id: id,
});

const setQuotaFormGetSuccess = (data) => ({
  type: tenantManagementActions.SET_QUOTA_FORM_GET_SUCCESS,
  data: data,
});

const setQuotaFormUpdateRequest = (id, payload) => ({
  type: tenantManagementActions.SET_QUOTA_FORM_UPDATE_REQUEST,
  id: id,
  payload: payload,
});

const setQuotaFormUpdateSuccess = (data) => ({
  type: tenantManagementActions.SET_QUOTA_FORM_UPDATE_SUCCESS,
  data: data,
});

const notificationFormRequest = (payload) => ({
  type: tenantManagementActions.NOTIFICATION_SETTINGS_FORM_REQUEST,
  payload: payload,
});

const notificationFormSuccess = (data) => ({
  type: tenantManagementActions.NOTIFICATION_SETTINGS_FORM_SUCCESS,
  data: data,
});

const notificationFormGetRequest = (id) => ({
  type: tenantManagementActions.NOTIFICATION_SETTINGS_GET_REQUEST,
  id: id,
});

const notificationFormGetSuccess = (data) => ({
  type: tenantManagementActions.NOTIFICATION_SETTINGS_GET_SUCCESS,
  data: data,
});

const notificationFormUpdateRequest = (payload) => ({
  type: tenantManagementActions.NOTIFICATION_SETTINGS_UPDATE_REQUEST,
  payload: payload,
});

const notificationFormUpdateSuccess = (data) => ({
  type: tenantManagementActions.NOTIFICATION_SETTINGS_UPDATE_SUCCESS,
  data: data,
});

const pricingProfileCreateRequest = (data) => ({
  type: tenantManagementActions.PRICING_PROFILE_CREATE_REQUEST,
  payload: data,
});

const setPricingProfileCreateSuccess = (data) => ({
  type: tenantManagementActions.PRICING_PROFILE_CREATE_SUCCESS,
  payload: data,
});

const setPricingProfileCreateError = (data) => ({
  type: tenantManagementActions.PRICING_PROFILE_CREATE_ERROR,
  payload: data,
});

const pricingProfileEditRequest = (data) => ({
  type: tenantManagementActions.PRICING_PROFILE_EDIT_REQUEST,
  payload: data,
});

const setPricingProfileEditSuccess = (data) => ({
  type: tenantManagementActions.PRICING_PROFILE_EDIT_SUCCESS,
  payload: data,
});

const setPricingProfileEditError = (data) => ({
  type: tenantManagementActions.PRICING_PROFILE_EDIT_ERROR,
  payload: data,
});

const getTenantSummary = (data) => ({
  type: tenantManagementActions.GET_TENANT_FORM_SUMMARY,
  payload: data,
});

const setTenantSummary = (data) => ({
  type: tenantManagementActions.SET_TENANT_FORM_SUMMARY,
  payload: data,
});

const setTenantSummaryError = (data) => ({
  type: tenantManagementActions.SET_TENANT_FORM_SUMMARY_ERROR,
  payload: data,
});

const createExtAndExp = (data) => ({
  type: tenantManagementActions.EXTENSION_FORM_CREATE,
  payload: data,
});

const setCreateExtAndExpData = (data) => ({
  type: tenantManagementActions.SET_EXTENSION_FORM_CREATE,
  payload: data,
});

const setCreateExtAndExpError = (data) => ({
  type: tenantManagementActions.SET_EXTENSION_FORM_CREATE_ERROR,
  payload: data,
});

const updateExtAndExp = (data) => ({
  type: tenantManagementActions.EXTENSION_FORM_UPDATE,
  payload: data,
});

const setUpdateExtAndExp = (data) => ({
  type: tenantManagementActions.SET_EXTENSION_FORM_UPDATE,
  payload: data,
});

const setUpdateExtAndExpError = (data) => ({
  type: tenantManagementActions.SET_EXTENSION_FORM_UPDATE_ERROR,
  payload: data,
});

const getExtAndExpData = (data) => ({
  type: tenantManagementActions.GET_EXTENSION_FORM_DATA,
  payload: data,
});

const setExtAndExpData = (data) => ({
  type: tenantManagementActions.SET_EXTENSION_FORM_DATA,
  payload: data,
});

const setExtAndExpDataError = (data) => ({
  type: tenantManagementActions.SET_EXTENSION_FORM_ERROR,
  payload: data,
});

const uploadHtmlTemplateRequest = (data) => ({
  type: tenantManagementActions.UPLOAD_HTML_TEMPLATE_REQUEST,
  payload: data,
});

const setUploadTemplateHtmlSuccess = (data) => ({
  type: tenantManagementActions.UPLOAD_HTML_TEMPLATE_SUCCESS,
  payload: data,
});

const setUploadTemplateHtmlError = (data) => ({
  type: tenantManagementActions.UPLOAD_HTML_TEMPLATE_ERROR,
  payload: data,
});

const getHtmlTemplateList = (data) => ({
  type: tenantManagementActions.HTML_TEMPLATE_FETCH_LIST_REQUEST,
  payload: data,
});

const setHtmlTemplateListSuccess = (data) => ({
  type: tenantManagementActions.HTML_TEMPLATE_FETCH_LIST_SUCCESS,
  payload: data,
});

const setHtmlTemplateListError = (data) => ({
  type: tenantManagementActions.HTML_TEMPLATE_FETCH_LIST_ERROR,
  payload: data,
});

const getTenantSettingsData = (data) => ({
  type: tenantManagementActions.GET_TENANT_SETTINGS_DATA,
  payload: data,
});

const setTenantSettingsData = (data) => ({
  type: tenantManagementActions.SET_TENANT_SETTINGS_DATA,
  payload: data,
});

const setTenantSettingsError = (data) => ({
  type: tenantManagementActions.SET_TENANT_SETTINGS_ERROR,
  payload: data,
});

const setTenantListLoading = (data) => ({
  type: tenantManagementActions.SET_TENANT_LIST_LOADING,
  payload: data,
});

export {
  tenantCreateUserRequest,
  tenantCreateUserSuccess,
  tenantEditUserRequest,
  tenantEditUserSuccess,
  getTenantListData,
  setTenantListData,
  setTenantListError,
  setExtAndExpDataError,
  deleteTenantData,
  tenantActionSuccess,
  deleteTenantError,
  setUpdateExtAndExpError,
  playPauseTenantData,
  playPauseTenantError,
  viewTenantRequest,
  viewTenantSuccess,
  uploadTenantLogo,
  setTenantLogoData,
  setTenantLogoError,
  setCreateExtAndExpError,
  getAccountManagers,
  setAccountManagers,
  setAccountManagersError,
  getCsmAdmins,
  setCsmAdmins,
  setCsmAdminsError,
  getMachineCatalogs,
  setMachineCatalogs,
  setMachineCatalogError,
  setTenantCreationData,
  getTenantDetailsById,
  setTenantDetailsById,
  setTenantDetailsErrorById,
  requestPricingProfile,
  successPricingProfile,
  errorPricingProfile,
  setQuotaFormRequest,
  setQuotaFormSuccess,
  setQuotaFormGetRequest,
  setQuotaFormGetSuccess,
  setQuotaFormUpdateRequest,
  setQuotaFormUpdateSuccess,
  notificationFormRequest,
  notificationFormSuccess,
  notificationFormGetRequest,
  notificationFormGetSuccess,
  notificationFormUpdateRequest,
  notificationFormUpdateSuccess,
  pricingProfileCreateRequest,
  setPricingProfileCreateSuccess,
  setPricingProfileCreateError,
  pricingProfileEditRequest,
  setPricingProfileEditSuccess,
  setPricingProfileEditError,
  getTenantSummary,
  setTenantSummary,
  setTenantSummaryError,
  tenantDeleteDataSuccess,
  createExtAndExp,
  setCreateExtAndExpData,
  updateExtAndExp,
  setUpdateExtAndExp,
  getExtAndExpData,
  setExtAndExpData,
  uploadHtmlTemplateRequest,
  setUploadTemplateHtmlSuccess,
  setUploadTemplateHtmlError,
  getHtmlTemplateList,
  setHtmlTemplateListSuccess,
  setHtmlTemplateListError,
  getTenantSettingsData,
  setTenantSettingsData,
  setTenantSettingsError,
  setTenantListLoading,
  setTenantListDataPaginated,
  getTenantListDataPaginated,
  resetTenantListDataPaginated,
};
